/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.4-12-g918a4012-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LdapUsernameAttributeFromJSON, LdapUsernameAttributeToJSON, } from './LdapUsernameAttribute';
import { TlsModeFromJSON, TlsModeToJSON, } from './TlsMode';
/**
 * Check if a given object implements the CreateLdapServerRequest interface.
 */
export function instanceOfCreateLdapServerRequest(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('host' in value) || value['host'] === undefined)
        return false;
    if (!('bindDn' in value) || value['bindDn'] === undefined)
        return false;
    if (!('bindPassword' in value) || value['bindPassword'] === undefined)
        return false;
    return true;
}
export function CreateLdapServerRequestFromJSON(json) {
    return CreateLdapServerRequestFromJSONTyped(json, false);
}
export function CreateLdapServerRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'host': json['host'],
        'port': json['port'] == null ? undefined : json['port'],
        'bindDn': json['bind_dn'],
        'bindPassword': json['bind_password'],
        'userFilter': json['user_filter'] == null ? undefined : json['user_filter'],
        'tlsMode': json['tls_mode'] == null ? undefined : TlsModeFromJSON(json['tls_mode']),
        'tlsVerify': json['tls_verify'] == null ? undefined : json['tls_verify'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'autoLinkSsoUsers': json['auto_link_sso_users'] == null ? undefined : json['auto_link_sso_users'],
        'description': json['description'] == null ? undefined : json['description'],
        'usernameAttribute': json['username_attribute'] == null ? undefined : LdapUsernameAttributeFromJSON(json['username_attribute']),
        'sshKeyAttribute': json['ssh_key_attribute'] == null ? undefined : json['ssh_key_attribute'],
        'uuidAttribute': json['uuid_attribute'] == null ? undefined : json['uuid_attribute'],
    };
}
export function CreateLdapServerRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'host': value['host'],
        'port': value['port'],
        'bind_dn': value['bindDn'],
        'bind_password': value['bindPassword'],
        'user_filter': value['userFilter'],
        'tls_mode': TlsModeToJSON(value['tlsMode']),
        'tls_verify': value['tlsVerify'],
        'enabled': value['enabled'],
        'auto_link_sso_users': value['autoLinkSsoUsers'],
        'description': value['description'],
        'username_attribute': LdapUsernameAttributeToJSON(value['usernameAttribute']),
        'ssh_key_attribute': value['sshKeyAttribute'],
        'uuid_attribute': value['uuidAttribute'],
    };
}
